
import { NgModule, Pipe } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AreaTecnicaComponent } from './areatecnica/areatecnica.component';
import { AtividadeComponent } from './atividade/atividade.component';
import { CategoriaComponent } from './categoria/categoria.component';
import { EmpreiteiraComponent } from './empreiteira/empreiteira.component';
/* import { EquipamentoComponent } from '../equipamento/equipamento.component'; */
import { FabricanteComponent } from './fabricante/fabricante.component';
import { FuncionarioComponent } from './funcionario/funcionario.component';
import { IrregularidadeComponent } from './irregularidade/irregularidade.component';
import { LocalComponent } from './local/local.component';
import { MaterialComponent } from './material/material.component';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

import { RotinaComponent } from './rotina/rotina.component';
import { UtilsModule } from 'src/app/utils/utils.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { TextMaskModule } from 'angular2-text-mask';
import { NgBootstrapFormValidationModule } from 'ng-bootstrap-form-validation';
import { SharedModule } from 'src/app/shareds/shareds.module';
import { EstoqueComponent } from './estoque/estoque.component';
import { ClasseEquipamentoComponent } from './classe-equipamento/classe-equipamento.component';
import { GrupoLocalNivelComponent } from './grupo-local-nivel/grupo-local-nivel.component';
import { CentroCustoComponent } from './centro-custo/centro-custo.component';
import { PrioridadeComponent } from './prioridade/prioridade.component';
import { TipoequipamentoComponent } from './tipoequipamento/tipoequipamento.component';

import { DigitOnlyModule } from '@uiowa/digit-only';
import { TipoMaterialComponent } from './tipo-material/tipo-material.component';
import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';

@NgModule({
    declarations: [
        AreaTecnicaComponent,
        AtividadeComponent,
        CategoriaComponent,
        EmpreiteiraComponent,
        //EquipamentoComponent,
        FabricanteComponent,
        FuncionarioComponent,
        IrregularidadeComponent,
        LocalComponent,
        MaterialComponent,
       
        RotinaComponent,
        EstoqueComponent,
        ClasseEquipamentoComponent,
        GrupoLocalNivelComponent,
        CentroCustoComponent,
        PrioridadeComponent,
        TipoequipamentoComponent,
        TipoMaterialComponent,
    ],
    imports: [
            CommonModule,
            UtilsModule,
            ReactiveFormsModule,
            AppRoutingModule,
            FormsModule,
            CurrencyMaskModule,
            TextMaskModule,
            NgBootstrapFormValidationModule,
            SharedModule,
            NgbModule,
            DigitOnlyModule,
            LoadingBarRouterModule,
            NgxLoadingModule.forRoot({
                animationType: ngxLoadingAnimationTypes.circle,
                backdropBorderRadius: '3px',
                primaryColour: '#3f6ad8',
              }),
          
            ],

            
})
export class CadastrosModule {

}
